<script setup lang="ts">
    import { ROUTES } from '@/router';
    import { useAuth } from '@/stores/auth';
    import { useUserStore } from '@/stores/userStore';
    import { computed } from 'vue';
    import { isTestEnvironment } from '@/util/env';
    import { formatUserName } from '@/domain/case/personName';
    import { APP_TARGETS } from '@/domain/analytics/analyticsTargets';

    const auth = useAuth();

    const userStore = useUserStore();
    const username = computed(() => formatUserName(userStore.user?.name));

    /**
     * This is a hack to get the integration test suite to work.
     * Ideally a component should not been modified with test behaviour but we could not find a way to
     * make testing-library work with this
     */
    const value = computed(() => isTestEnvironment());
</script>

<template>
    <v-menu
        :model-value="value"
        max-height="500"
        max-width="500"
        content-class="profile-menu"
        transition="fade-transition"
        :open-on-hover="true"
        location="bottom"
        offset="30"
        open-delay="0"
        close-delay="0"
    >
        <template #activator="{ props }">
            <v-hover>
                <template #default="{ isHovering, props: hoverProps }">
                    <app-menu-item
                        data-testid="header-profile-menu"
                        :data-analytics-id="APP_TARGETS.profileMenuIcon"
                        v-bind="{ ...hoverProps }"
                        :background="isHovering ? 'light' : 'dark'"
                        class="cursor-pointer mr-5"
                        icon="mdi-account"
                        @focus="props.onFocus"
                        @blur="props.onBlur"
                        @mouseenter="props.onMouseenter"
                        @mouseleave="props.onMouseleave"
                    />
                </template>
            </v-hover>
        </template>
        <v-card
            dense
            min-width="400"
            color="dark-blue"
            class="notifications-card"
            data-testid="header-profile-menu-content"
        >
            <v-list dense class="pa-5 overflow-y-auto">
                <v-list-item data-testid="username-menu-item" class="font-weight-bold">
                    {{ username }}
                </v-list-item>
                <v-divider />
                <v-list-item
                    v-if="!userStore.isSurgicalSupportEngineer"
                    :to="{ name: ROUTES.PREFERENCES }"
                    tag="router-link"
                    data-testid="preferences-page-menu-option"
                >
                    Preferences
                </v-list-item>

                <v-divider />

                <v-list-item
                    :to="{ name: ROUTES.LOGIN }"
                    tag="router-link"
                    data-testid="logout-menu-option"
                    append-icon="mdi-logout"
                    @click="() => auth.logout()"
                >
                    Logout
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<style scoped lang="scss">
    .profile-menu {
        .v-list {
            background: rgb(var(--v-theme-dark-background));
            color: rgb(var(--v-theme-on-dark-background));
        }
    }
</style>
